import React from 'react'

import './SocialAuthButton.scss'

interface SocialAuthButtonProps {
  readonly label: string
  readonly icon?: JSX.Element
  readonly 'data-testid'?: string
  onClick(): void
}

const SocialAuthButton: React.FC<SocialAuthButtonProps> = ({ label, icon, onClick, 'data-testid': dataTestId }) => {
  const hasIcon = !!icon

  return (
    <button
      type="button"
      className="SocialAuthButton"
      onClick={onClick}
      data-testid={dataTestId}
    >
      {hasIcon && icon}
      {label}
    </button>
  )
}

export default SocialAuthButton
